import { render } from "./htmlVideo.vue?vue&type=template&id=31819ee2"
import script from "./htmlVideo.vue?vue&type=script&lang=js"
export * from "./htmlVideo.vue?vue&type=script&lang=js"

import "./htmlVideo.vue?vue&type=style&index=0&id=31819ee2&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__